import * as React from 'react';
import {Button, ButtonGroup, Col} from 'reactstrap';
import renderDatePickerField from '../../../theme/components/form/DatePicker';
import {Field, InjectedFormProps, reduxForm} from 'redux-form';
import CalendarBlankIcon from 'mdi-react/CalendarBlankIcon';
import validate from './validate';
import * as moment from 'moment';

class ResumenForm extends React.PureComponent<InjectedFormProps> {

    public render() {
        const {handleSubmit, defaultDate} = this.props;
        return (
            <form className='form' onSubmit={handleSubmit}>
                <Col md={7}>
                    <div className='form__form-group'>
                        <label className='form__form-group-label'>Fecha</label>
                        <div className='form__form-group-field'>
                            <Field
                                name='fecha'
                                component={renderDatePickerField}
                                filterDate={(date) => {
                                    return moment() > date;
                                }}
                                defaultDate={defaultDate ? defaultDate : moment()}
                                placeholder='dd/mm/yyyy'
                            />
                            <div className='form__form-group-icon'>
                                <CalendarBlankIcon/>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col md={5}>
                    <ButtonGroup className='btn-group--justified' style={{marginTop: 22}}>
                        <Button color='success' type='submit'>FILTRAR</Button>
                    </ButtonGroup>
                </Col>
            </form>
        )
    }
}

export default reduxForm({
    form: 'resumen_form', // a unique identifier for this form
    validate,
})(ResumenForm);


// WEBPACK FOOTER //
// ./src/components/pages/portada/resumen-form.tsx